/* eslint-disable react/no-array-index-key -- Array is not dynamic therefore we dont need this rule */
import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { Root } from '../../../../components/SiteLinks/components/Group/styles';
import { LINK_COLUMN } from './constants';
import { LinkLabelSkeleton, ListLink } from './styles';
import { type LinkColumnProps } from './types';

export const LinkColumn: FC<LinkColumnProps> = ({ customSkeletons, children, ...rest }) => {
  const { getTestId } = useTestId();

  return (
    <Root
      data-testid={getTestId(LINK_COLUMN)}
      {...rest}
    >
      <Typography
        role="heading"
        variant="h6"
      >
        <LinkLabelSkeleton width={85} />
      </Typography>
      {customSkeletons ? (
        customSkeletons.map(({ skeletonWidth }, index) => (
          <ListLink
            key={index}
            role="listitem"
            width={`${skeletonWidth}%`}
          />
        ))
      ) : (
        <>
          <ListLink
            role="listitem"
            width="80%"
          />
          <ListLink
            role="listitem"
            width="100%"
          />
          <ListLink
            role="listitem"
            width="30%"
          />
          <ListLink
            role="listitem"
            width="90%"
          />
          <ListLink
            role="listitem"
            width="45%"
          />
        </>
      )}
      {children}
    </Root>
  );
};
